import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  LineEnding_Default_instance = new (LineEnding())('Default', 0);
  LineEnding_Lenient_instance = new (LineEnding())('Lenient', 1);
}
var LineEnding_Default_instance;
var LineEnding_Lenient_instance;
var LineEndingClass;
function LineEnding() {
  if (LineEndingClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'LineEnding');
    LineEndingClass = $;
  }
  return LineEndingClass;
}
function LineEnding_Default_getInstance() {
  static_init();
  return LineEnding_Default_instance;
}
function LineEnding_Lenient_getInstance() {
  static_init();
  return LineEnding_Lenient_instance;
}
//region block: exports
export {
  LineEnding_Default_getInstance as LineEnding_Default_getInstance1v5asezcrl1hi,
  LineEnding_Lenient_getInstance as LineEnding_Lenient_getInstance1bc8w98h8if6n,
};
//endregion

//# sourceMappingURL=LineEnding.mjs.map
